/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Select from 'react-select';
import styles from './HSNReportPageComp.module.css';
import DashboardSection from '../DashboardContainer/DashboardSection';
import DomainTile from '../DomainTile/DomainTile';
import ReusableTable from '../ReusableTable/ReusableTable';
import config from '../../config/config';
import { useHistory } from 'react-router-dom';
import $ from 'jquery';
import axios from 'axios';



const { API_BASE_URL } = config;
const HSNDetailReportPageComp = () => {

  // const [materialNo, setmaterialNo] = useState();
  const [selectedMaterial, setSelectedGLMaterial] = useState();
  const [selectedMaterialAPI, setSelectedGLMaterialAPI] = useState();
  const [tableData, settableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(100);
  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState(0);
  const [dataLoading, setdataLoading] = useState(false);
  const selectMLRef = useRef();
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  const columns = [
    { header: "Sr. No.", accessor: "srNo" },
    { header: "matnr", accessor: "matnr" },
    { header: "maktx", accessor: "maktx" },
    { header: "hsn_cv", accessor: "hsn_cv" },
    { header: "hsn_pv", accessor: "hsn_pv" },
    { header: "hsn_ev", accessor: "hsn_ev" },

  ];

  const memoizedOptions = useMemo(() => selectedMaterialAPI, [selectedMaterialAPI]);

  // useEffect(() => {
  //   const MaterialListData = async () => {
  //     const headerss = new Headers();
  //     headerss.append("Authorization", `Bearer ${localStorage.getItem("ApiToken")}`)
  //     const url = `${API_BASE_URL}/api/material_number`
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: headerss,
  //     })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //     if (response?.ok) {
  //       // eslint-disable-next-line
  //       const MaterialCode = await response.json();
  //       setSelectedGLMaterialAPI(await MaterialCode);
  //       // handleChangeglcode(MaterialCode)
  //     } else {
  //       history.push('/Page-Not-Found');
  //     }
  //   };
  //   // MaterialListData();
  //   setTimeout(() => {
  //     MaterialListData();
  //   }, 2000);
  // }, []);

  useEffect(() => {
    const MaterialListData = async () => {
      const headerss = new Headers();
      headerss.append("Authorization", `Bearer ${localStorage.getItem("ApiToken")}`)
      const url = `${API_BASE_URL}/api/material_number`;
      const response = await fetch(url, { method: 'GET', headers: headerss }).catch(console.log);

      if (response?.ok) {
        const MaterialCode = await response.json();
        setSelectedGLMaterialAPI(MaterialCode);  // full dataset
        setFilteredOptions(MaterialCode.slice(0, 1000)); // initial display
      } else {
        history.push('/Page-Not-Found');
      }
    };

    setTimeout(MaterialListData, 2000);
  }, []);

  useEffect(() => {
    showData()
  }, [selectedPage])

  const handleSearch = (inputValue) => {
    if (!inputValue) {
      setFilteredOptions(selectedMaterialAPI.slice(0, 1000)); // default first 1000
      return;
    }

    const filtered = selectedMaterialAPI.filter(option =>
      option.gl.toLowerCase().includes(inputValue.toLowerCase())
    );

    setFilteredOptions(filtered.slice(0, 1000)); // optional slice for performance
  };


  const handleCSVDownload = async () => {
    setIsLoading(true)
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/HsnReportDetailTableExcelDataCV`,
        {
          glnum: selectedMaterial || '',
          start: startPage,
          length: endPage
        },
        {
          headers: {
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            'Content-Type': 'application/json',
          },
          responseType: 'blob'
        }
      );


      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });


      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'Hsn_Detail_Report_Cv.csv';
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match && match[1]) fileName = match[1];
      }


      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', fileName);


      document.body.appendChild(link);
      link.click();


      link.remove();
      window.URL.revokeObjectURL(url);
      setIsLoading(false)
    } catch (error) {
      console.error('CSV download failed:', error);
    }
  };


  const handleReset = () => {
    location.reload()
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
    let endPageVal = page * 100
    let startPageVal = endPageVal - 99

    setStartPage(startPageVal)
    setEndPage(endPageVal)
    // console.log(`Selected page: ${page}`);

  };


  const handleChangeglcode = (value) => {
    if (value === 'undefined' || value === null) {
      setSelectedGLMaterial(undefined);
    } else {
      // setSelectedGLnumber(value)
      const value1 = Array.from(value, getOptionValue => getOptionValue.gl);
      console.log('test ---------------->', value1)
      setSelectedGLMaterial(value1);
    }
  }


  const showData = async () => {
    // debugger
    try {
      setdataLoading(true)
      // if (selectedMaterial) {
      //   setStartPage(1)
      //   setEndPage(100)
      //   // setSelectedPage(0);
      //   //  setTotalRecords(selectedMaterial.length)
      // }

      const response = await axios.post(`${API_BASE_URL}/api/material_table`,
        {
          glnum: selectedMaterial || '',
          start: selectedMaterial ? 1 : startPage,
          length: selectedMaterial ? 100 : endPage

        },

        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // console.log(response.data, "repsonde MOnth")
          settableData(response.data.data)
          setTotalRecords(response.data.recordsTotal)
          setdataLoading(false)
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  }




  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className='row mb-4'>
          <div className='col-6'>
            <div className={styles.filter_panel_row}>
              <div className={styles.filter_panel_col}>
                <label className={styles.filter_label}>Material Number</label>
                <div className={styles.filter_select_wrapper}>
                  <Select
                    options={filteredOptions}
                    isMulti
                    isSearchable
                    getOptionLabel={e => e.gl}
                    getOptionValue={e => e.gl}
                    onChange={handleChangeglcode}
                    onInputChange={handleSearch} // <-- custom search handler
                    closeMenuOnSelect={false}
                    menuShouldScrollIntoView={false}
                    filterOption={null} // disable default filter
                  />


                </div>
              </div>
              <div className="filter-panel-col action-buttons">
                <button onClick={showData} className="btn apply-btn">
                  Apply
                </button>
                <button onClick={handleReset} className="btn reset-btn">
                  Reset
                </button>
              </div>


            </div></div>
        </div>
        <div>
          <div className="row" >
            <div className="col-md-12">
              <DomainTile title='HSN Exception Report' showBackButton={false} />
            </div>
          </div>

      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Downloading...</p>
  
          </div>
        </div>
      )}

          <div className="row">
            <div className="col-md-12">
              <DashboardSection title="" disableDetailView={true}>
                {/* <h2> tabel here</h2> */}
                <ReusableTable
                  data={tableData}
                  columns={columns}
                  itemsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                  isCustomOpen={true}
                  totalRecords={totalRecords}
                  handleCSVDownload={handleCSVDownload}
                  dataLoading={dataLoading}
                />
              </DashboardSection>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HSNDetailReportPageComp;
